/* eslint import/first: 0 */
import '@dxb-web-ui-framework/common/utils/DeveloperTools';

if (process.env.REACT_APP_MSW) {
  const { worker } = require('../../packages/mocks/src/msw/browser');
  worker.start();
}

import React from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline, MuiThemeProvider } from '@dxb-web-ui-framework/design-system';
import { AppBootstrappingProvider } from '@dxb-web-ui-framework/common/contexts/AppBootstrapping/AppBootstrappingProvider';
import { Brand } from '@dxb-web-ui-framework/common/domain/Brand/types';
import { Tenant } from '@dxb-web-ui-framework/common/domain/Tenant/types';
import { Channel } from '@dxb-web-ui-framework/common/domain/Channel/types';
import { UIStateProvider } from '@dxb-web-ui-framework/common/contexts/UIState/UIStateProvider';
import { ConnectedToUIStateStyledGlobalErrorBoundary } from '@dxb-web-ui-framework/common/components/GlobalErrorBoundary/GlobalErrorBoundary';
import { AppConfigurationProvider } from '@dxb-web-ui-framework/common/contexts/AppConfiguration/AppConfigurationProvider';
import { GlobalStyles } from '@dxb-web-ui-framework/common/components/GlobalStyles/GlobalStyles';
import { reportWebVitals } from '@dxb-web-ui-framework/common/utils/ReportWebVitals';
import { ECOMMBX } from '@dxb-web-ui-framework/design-system';
import { InternationalizationProvider } from '../../packages/internationalization/src/contexts/Internationalization';
import { InternationalizationRepositoryImpl } from '../../packages/internationalization/src/domain/Internationalization/infrastructure';
import { InternationalizationServiceImpl } from '../../packages/internationalization/src/domain/Internationalization/usecases/InternationalizationService';
import { AppError } from '../../packages/content-composer/src/components/Generic/AppError';
import { AppLoader } from '../../packages/content-composer/src/components/Generic/AppLoader';
import { brandedAppConfig } from './buildtime-config/brandedAppConfig';
import { App } from './App';

const internationalizationService = new InternationalizationServiceImpl(new InternationalizationRepositoryImpl());

ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider theme={ECOMMBX}>
      <CssBaseline />
      <GlobalStyles />
      <AppBootstrappingProvider
        brand={Brand.ECOMMBX}
        channel={Channel.ECOMMBX}
        appName={Channel.PUBLIC_WEB}
        tenant={Tenant.ECOMMBX}
        userAgentType='Web'>
        <UIStateProvider>
          <ConnectedToUIStateStyledGlobalErrorBoundary isRoot>
            <AppConfigurationProvider
              loaderComponent={<AppLoader />}
              errorComponent={
                <AppError message='Houston we have a problem. Failed to initialise app' btnLabel='Back to home' />
              }>
              <InternationalizationProvider
                internationalizationService={internationalizationService}
                loaderComponent={<AppLoader />}
                errorComponent={
                  <AppError
                    fullHeight
                    message='Houston we have a problem. Failed to load translations'
                    btnLabel='Back to home'
                  />
                }>
                <App brandConfig={brandedAppConfig} />
              </InternationalizationProvider>
            </AppConfigurationProvider>
          </ConnectedToUIStateStyledGlobalErrorBoundary>
        </UIStateProvider>
      </AppBootstrappingProvider>
    </MuiThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
